<footer class="container px-3 gx-0 gx-lmd-20 gx-lg-0 gx-xl-20 container-footer">
    <section class="row d-none d-sm-flex gx-21 mt-9 w-100 desktop">
        <div class="col-6 col-flmd-4 col-lg-3">
            <div class="container-footer-item mb-27">
                <p class="container-footer-title fw-bold mb-25">
                    {{ 'fe_core_footer_p_title_customer-service' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_customer-service' | translate
                    "
                >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'contact-us-and-faqs' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_customer-service' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'questions' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{ 'fe_core_footer_link_faqs' | translate }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [icon]="'arrow-right-purple'"
                        [href]="'fe_core_footer_link_billing-href' | translate"
                        [target]="'_blank'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_billing' | translate
                        }}</fe-button
                    >
                </nav>
            </div>
            <div class="container-footer-item mb-27">
                <p class="container-footer-title fw-bold mb-25">
                    {{ 'fe_core_footer_p_title_reservations' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_reservations' | translate
                    "
                >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'/' | formatUrl"
                        [fragment]="'doReservation'"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_reservation' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'check-your-reservation' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        *ngIf="
                            configuration.featuresFlags.value
                                ?.viewCancelReservation === true
                        "
                        >{{
                            'fe_core_footer_link_view-cancel-reservation'
                                | translate
                        }}</fe-button
                    >
                    <fe-button
                        *ngIf="
                            configuration.featuresFlags.value?.precheckin ===
                            true
                        "
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'pre-check-in' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_precheckin' | translate
                        }}</fe-button
                    >
                </nav>
            </div>
        </div>
        <div class="col-6 col-flmd-4 col-lg-3">
            <div class="container-footer-item mb-27">
                <p class="container-footer-title fw-bold mb-25">
                    {{ 'fe_core_footer_p_title_promotions' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_promotions' | translate
                    "
                >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'promos-and-agreements' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_promotions' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'promos-and-agreements' | formatUrl"
                        [fragment]="'register-email'"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_subscribe-mailing' | translate
                        }}</fe-button
                    >
                </nav>
            </div>
            <div class="container-footer-item mb-27">
                <p class="container-footer-title fw-bold mb-25">
                    {{ 'fe_core_footer_p_title_destinations' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_destinations' | translate
                    "
                >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'destination-airport/4/city' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_1-destination' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'destination-airport/38/city' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_2-destination' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'destination-airport/73/city' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_3-destination' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'locations-and-offices' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_more-destinations' | translate
                        }}</fe-button
                    >
                </nav>
            </div>
        </div>
        <div class="col-6 col-flmd-4 col-lg-3">
            <div class="container-footer-item mb-27">
                <p class="container-footer-title fw-bold mb-25">
                    {{ 'fe_core_footer_p_title_programs' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_programs' | translate
                    "
                >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'corporate' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_corporate' | translate
                        }}</fe-button
                    >
                </nav>
            </div>
            <div class="container-footer-item mb-27">
                <p class="container-footer-title fw-bold mb-25">
                    {{ 'fe_core_footer_p_title_company' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_company' | translate
                    "
                >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'about-us' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_about-alamo' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'https://mx.computrabajo.com/alamo-rent-a-car'"
                        target="_blank"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_careers' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="
                            'questions/car-rental-conditions-and-policies'
                                | formatUrl
                        "
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_rental-policy' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'questions/privacy-policy' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_privacy-policy' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'questions/terms-of-use' | formatUrl"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_terms-use' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="
                            'https://privacy.ehi.com/es-us/home/cookie-policy.html'
                        "
                        target="_blank"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{
                            'fe_core_footer_link_cookie-policy' | translate
                        }}</fe-button
                    >
                    <fe-button
                        class="mb-13"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'/blog'"
                        target="_blank"
                        [icon]="'arrow-right-purple'"
                        [iconPosition]="'right'"
                        >{{ 'fe_core_footer_link_blog' | translate }}</fe-button
                    >
                </nav>
            </div>
        </div>
        <div class="col-6 col-flmd-12 col-lg-3">
            <div class="row gx-21">
                <div class="col-12 col-flmd-4 col-lg-12">
                    <div class="container-footer-item mb-27">
                        <p class="container-footer-title fw-bold mb-25">
                            {{
                                'fe_core_footer_p_title_contact-us' | translate
                            }}
                        </p>
                        <nav
                            [attr.aria-label]="
                                'fe_core_footer_p_title_contact-us' | translate
                            "
                        >
                            <fe-button
                                class="mb-13"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_whatsapp' | translate"
                                target="_blank"
                                [icon]="'arrow-right-purple'"
                                [iconPosition]="'right'"
                                >{{
                                    'fe_core_footer_link_send-whatsapp'
                                        | translate
                                }}</fe-button
                            >
                            <fe-button
                                class="mb-13"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="
                                    'fe_core_footer_number_call-us' | translate
                                "
                                target="_blank"
                                [icon]="'arrow-right-purple'"
                                [iconPosition]="'right'"
                                >{{
                                    'fe_core_footer_link_call-us' | translate
                                }}</fe-button
                            >
                        </nav>
                    </div>
                </div>
                <div class="col-12 col-flmd-4 col-lg-12">
                    <div class="container-footer-item">
                        <p class="container-footer-title fw-bold mb-25">
                            {{ 'fe_core_footer_p_title_follow-us' | translate }}
                        </p>
                        <nav
                            [attr.aria-label]="
                                'fe_core_footer_p_title_follow-us' | translate
                            "
                            class="d-flex"
                        >
                            <fe-button
                                class="mb-13 me-3"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_facebook' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/facebook.png' | cdn"
                                    alt="Facebook"
                                />
                            </fe-button>
                            <fe-button
                                class="mb-13 me-3"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_twitter' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/gorjeo.png' | cdn"
                                    alt="X"
                                />
                            </fe-button>
                            <fe-button
                                class="mb-13 me-3"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_instagram' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/instagram-(1).png' | cdn"
                                    alt="Instagram"
                                />
                            </fe-button>
                            <fe-button
                                class="mb-13"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_spotify' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/spotify.png' | cdn"
                                    alt="Spotify"
                                />
                            </fe-button>
                        </nav>
                    </div>
                    <div class="container-footer-item mb-27">
                        <nav
                            [attr.aria-label]="
                                'fe_core_footer_p_title_follow-us' | translate
                            "
                            class="d-flex"
                        >
                            <fe-button
                                class="me-3"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_tiktok' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/tik-tok.png' | cdn"
                                    alt="TikTok"
                                />
                            </fe-button>
                            <fe-button
                                class="me-3"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_pinterest' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/pinterest.png' | cdn"
                                    alt="Pinterest"
                                />
                            </fe-button>
                            <fe-button
                                class="me-3"
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_youtube' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/youtube.png' | cdn"
                                    alt="YouTube"
                                />
                            </fe-button>
                            <fe-button
                                [btnClass]="'p-0 text-nowrap'"
                                [style]="'link-tertiary'"
                                [href]="'fe_core_footer_linkedin' | translate"
                                target="_blank"
                            >
                                <img
                                    [src]="'images/linkedin.png' | cdn"
                                    alt="LinkedIn"
                                />
                            </fe-button>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="container-footer-item mb-27">
                <p class="container-footer-rights-reserved">
                    {{
                        'fe_core_footer_p_title_all-rights-reserved' | translate
                    }}
                </p>
            </div>
        </div>
    </section>
    <section
        class="accordion row d-flex gx-0 d-sm-none mb-21"
        ngbAccordion
        [closeOthers]="true"
    >
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_customer-service' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_customer-service'
                                | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'contact-us-and-faqs' | formatUrl"
                            >{{
                                'fe_core_footer_link_customer-service'
                                    | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'questions' | formatUrl"
                            >{{
                                'fe_core_footer_link_faqs' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="
                                'fe_core_footer_link_billing-href' | translate
                            "
                            [target]="'_blank'"
                            >{{
                                'fe_core_footer_link_billing' | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_reservations' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_reservations' | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'/' | formatUrl"
                            [fragment]="'doReservation'"
                            >{{
                                'fe_core_footer_link_reservation' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'check-your-reservation' | formatUrl"
                            *ngIf="
                                configuration.featuresFlags.value
                                    ?.viewCancelReservation === true
                            "
                            >{{
                                'fe_core_footer_link_view-cancel-reservation'
                                    | translate
                            }}</fe-button
                        >
                        <fe-button
                            *ngIf="
                                configuration.featuresFlags.value
                                    ?.precheckin === true
                            "
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'pre-check-in' | formatUrl"
                            >{{
                                'fe_core_footer_link_precheckin' | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_promotions' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_promotions' | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'promos-and-agreements' | formatUrl"
                            >{{
                                'fe_core_footer_link_promotions' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'promos-and-agreements' | formatUrl"
                            [fragment]="'register-email'"
                            >{{
                                'fe_core_footer_link_subscribe-mailing'
                                    | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_programs' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_programs' | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'corporate' | formatUrl"
                            >{{
                                'fe_core_footer_link_corporate' | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_destinations' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_destinations' | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'destination-airport/3/city' | formatUrl"
                            >{{
                                'fe_core_footer_link_1-destination' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'destination-airport/18/city' | formatUrl"
                            >{{
                                'fe_core_footer_link_2-destination' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'destination-airport/28/city' | formatUrl"
                            >{{
                                'fe_core_footer_link_3-destination' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'locations-and-offices' | formatUrl"
                            >{{
                                'fe_core_footer_link_more-destinations'
                                    | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_company' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_company' | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'about-us' | formatUrl"
                            >{{
                                'fe_core_footer_link_about-alamo' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="
                                'https://mx.computrabajo.com/alamo-rent-a-car'
                            "
                            target="_blank"
                            >{{
                                'fe_core_footer_link_careers' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="
                                'questions/car-rental-conditions-and-policies'
                                    | formatUrl
                            "
                            >{{
                                'fe_core_footer_link_rental-policy' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'questions/privacy-policy' | formatUrl"
                            >{{
                                'fe_core_footer_link_privacy-policy' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'questions/terms-of-use' | formatUrl"
                            >{{
                                'fe_core_footer_link_terms-use' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="
                                'https://privacy.ehi.com/es-us/home/cookie-policy.html'
                            "
                            target="_blank"
                            >{{
                                'fe_core_footer_link_cookie-policy' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'/blog'"
                            target="_blank"
                            >{{
                                'fe_core_footer_link_blog' | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div
            [collapsed]="ssr.isPlatformBrowser()"
            ngbAccordionItem
            class="accordion-item col-12"
        >
            <p ngbAccordionHeader class="accordion-header">
                <button
                    ngbAccordionButton
                    class="accordion-button collapsed p-0 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                >
                    {{ 'fe_core_footer_p_title_contact-us' | translate }}
                </button>
            </p>
            <div ngbAccordionCollapse class="accordion-collapse collapse">
                <div class="accordion-body">
                    <nav
                        [attr.aria-label]="
                            'fe_core_footer_p_title_contact-us' | translate
                        "
                    >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'fe_core_footer_whatsapp' | translate"
                            target="_blank"
                            >{{
                                'fe_core_footer_link_send-whatsapp' | translate
                            }}</fe-button
                        >
                        <fe-button
                            class="mb-13"
                            [btnClass]="'p-0 text-nowrap'"
                            [style]="'link-tertiary'"
                            [href]="'fe_core_footer_number_call-us' | translate"
                            target="_blank"
                            >{{
                                'fe_core_footer_link_call-us' | translate
                            }}</fe-button
                        >
                    </nav>
                </div>
            </div>
        </div>
        <div class="col-12 mt-21 align-">
            <div class="container-footer-item">
                <p class="container-footer-title fw-bold">
                    {{ 'fe_core_footer_p_title_follow-us' | translate }}
                </p>
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_follow-us' | translate
                    "
                    class="d-flex"
                >
                    <fe-button
                        class="me-3"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_facebook' | translate"
                        target="_blank"
                    >
                        <img
                            [src]="'images/facebook.png' | cdn"
                            alt="Facebook"
                        />
                    </fe-button>
                    <fe-button
                        class="me-3"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_twitter' | translate"
                        target="_blank"
                    >
                        <img [src]="'images/gorjeo.png' | cdn" alt="X" />
                    </fe-button>
                    <fe-button
                        class="me-3"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_instagram' | translate"
                        target="_blank"
                    >
                        <img
                            [src]="'images/instagram-(1).png' | cdn"
                            alt="Instagram"
                        />
                    </fe-button>
                    <fe-button
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_spotify' | translate"
                        target="_blank"
                    >
                        <img [src]="'images/spotify.png' | cdn" alt="Spotify" />
                    </fe-button>
                </nav>
            </div>
        </div>
        <div class="col-12 mt-2">
            <div class="container-footer-item mb-21">
                <nav
                    [attr.aria-label]="
                        'fe_core_footer_p_title_follow-us' | translate
                    "
                    class="d-flex"
                >
                    <fe-button
                        class="me-3"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_tiktok' | translate"
                        target="_blank"
                    >
                        <img [src]="'images/tik-tok.png' | cdn" alt="TikTok" />
                    </fe-button>
                    <fe-button
                        class="me-3"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_pinterest' | translate"
                        target="_blank"
                    >
                        <img
                            [src]="'images/pinterest.png' | cdn"
                            alt="Pinterest"
                        />
                    </fe-button>
                    <fe-button
                        class="me-3"
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_youtube' | translate"
                        target="_blank"
                    >
                        <img [src]="'images/youtube.png' | cdn" alt="YouTube" />
                    </fe-button>
                    <fe-button
                        [btnClass]="'p-0 text-nowrap'"
                        [style]="'link-tertiary'"
                        [href]="'fe_core_footer_linkedin' | translate"
                        target="_blank"
                    >
                        <img
                            [src]="'images/linkedin.png' | cdn"
                            alt="LinkedIn"
                        />
                    </fe-button>
                </nav>
            </div>
        </div>
        <div class="col-12">
            <div class="container-footer-item mb-27">
                <p class="container-footer-rights-reserved">
                    {{
                        'fe_core_footer_p_title_all-rights-reserved' | translate
                    }}
                </p>
            </div>
        </div>
    </section>
</footer>
